import React from "react";
import FeatureCard from "../component/FeatureCard";
const awesome = [
  {
    id: 1,
    icon: "/assets/hall-6.jpg",
    title: "Exclusive restaurant",
  },
  {
    id: 2,
    icon: "/assets/awesome-2.svg",
    title: "CCTV Surveillance",
  },
  {
    id: 3,
    icon: "/assets/awesome-3.svg",
    title: "Free Wifi",
  },
  {
    id: 4,
    icon: "/assets/awesome-4.svg",
    title: "Event space",
  },
  {
    id: 5,
    icon: "/assets/awesome-5.svg",
    title: "Wide Parking",
  },
  {
    id: 6,
    icon: "/assets/awesome-6.svg",
    title: "24/7 Check-in & out",
  },
];

const cardData = [
  {
    id: 1,
    description: "A fine dining landmark in New York City, ",
    icon: "public/assets/hall-6.jpg",
  },
  {
    id: 2,
    description:
      "CCTV surveillance monitors public spaces for safety and security.",
    icon: "/assets/aws-1.svg",
  },
  {
    id: 3,
    description: "Free Wi-Fi is available for all customers.",
    icon: "/assets/aws-2.svg",
  },
  {
    id: 4,
    description: "Our event space is perfect for any occasion.",
    icon: "/assets/aws-3.svg",
  },
  {
    id: 5,
    description: "Wide parking spaces available for all vehicles.",
    icon: "/assets/aws-4.svg",
  },
  {
    id: 6,
    description: "Enjoy 24/7 check-in and check-out convenience.",
    icon: "/assets/aws-5.svg",
  },
];

const Specialties = () => {
  return (
    <div className=" bg-[#FFFEF2] p-5 md:p-20">
      <div className=" flex justify-center items-center flex-col">
        <h1 className=" font-calson font-medium text-[40px] md:text-[64px] text-nowrap text-primary ">
          Awesome facilities
        </h1>
        <span className=" font-creto text-[12px] text-nowrap  md:text-[20px] font-light text-primary">
          Our hotel has been present for over 20 years.
        </span>
      </div>
      <div className=" grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 place-items-center mt-10 mx-auto max-w-7xl">
        {awesome.map((awe, i) => {
          const item = cardData?.[i];
          const desc = item?.description || "";
          const hoverIcon = item?.icon || "";

          return (
            <div key={awe.id} className="flex flex-col group w-full justify-center items-center">
              <div
                className="
                relative
                w-full h-[200px]
                md:w-[353px] md:h-[234px]
                overflow-hidden
                hover:scale-105 
                //hover:rotate-2
              "
              >
                {/* Base Image */}
                <img
                  src={awe.icon}
                  alt={awe.title}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />

                {/* Light overlay */}
                {/* <div className="absolute inset-0 bg-[#E7D7A5]/20 opacity-0 group-hover:opacity-100 transition-opacity duration-500" /> */}

                {/* ✅ Hover FeatureCard (icon + desc will match each card) */}
                {/* <div
                  className="
                  absolute inset-0
                  opacity-0 translate-y-6
                  transition-all duration-500
                  group-hover:opacity-100
                  group-hover:translate-y-0
                  z-20
                "
                >
                  <FeatureCard icon={hoverIcon} description={desc} />
                </div> */}
              </div>

              {/* Title */}
              <p className="font-creto font-medium text-[20px] md:text-[30px] text-primary mt-2 text-center">
                {awe.title}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Specialties;
